import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useCatchUpParams } from 'src/components/Listings/InventoryEventPage/InventoryEventPage.hooks';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { StopwatchLoggingContextProvider } from 'src/contexts/StopwatchLoggingContext';
import { LayoutContent } from 'src/navigations/LayoutContent';
import {
  EventIdQueryParam,
  InventoryDeeplinkQueryParam,
} from 'src/utils/constants/constants';
import { removeDeepLinkUrlPartsFromRelativeUrl } from 'src/utils/deepLinkUtils';
import { EventPageLocationState } from 'src/utils/types/EventPageLocationState';
import { CatchUpModeSource } from 'src/WebApiController';

import {
  ACTIVE_EVENT_IDS_2_QUERY_PARAM,
  TAB_EVENT_IDS_2_QUERY_PARAM,
  TAB_EVENT_IDS_MAPPING_ID,
} from '../InventoryEvent/InventoryEvent.constants';
import { MainRoute } from '../MainRoute';
import * as styles from './OnSaleEvent.css';
import { OnSaleEventPage } from './OnSaleEventPage';

export const OnSaleEvent = () => {
  const [searchParams] = useSearchParams();
  const viagEventId = searchParams.get(EventIdQueryParam);
  const { activeViagVirtualId } = useCatchUpParams(
    CatchUpModeSource.OnSaleEvents
  );

  const sanitizedEventId = useMemo(() => {
    if (viagEventId) {
      return viagEventId;
    }
    return activeViagVirtualId;
  }, [activeViagVirtualId, viagEventId]);

  const location = useLocation();

  // Only use value provided at the first time (should be from '/discovery')
  const returnUrl = useMemo(() => {
    const locationState = (location.state ?? {}) as EventPageLocationState;

    if (locationState.returnUrl && locationState.keepReturnUrlUnchanged) {
      return locationState.returnUrl;
    }

    const relativeUrl = locationState.returnUrl || location.search;

    return removeDeepLinkUrlPartsFromRelativeUrl(relativeUrl, [
      InventoryDeeplinkQueryParam,
      ACTIVE_EVENT_IDS_2_QUERY_PARAM,
      TAB_EVENT_IDS_2_QUERY_PARAM,
      TAB_EVENT_IDS_MAPPING_ID,
    ]);
  }, [location.state, location.search]);

  if (!sanitizedEventId || isNaN(Number(sanitizedEventId))) {
    return null;
  }

  return (
    <StopwatchLoggingContextProvider>
      <DialogProvider>
        <LayoutContent mainRoute={MainRoute.DiscoveryEvent} routeTitle="">
          <div className={styles.pageContainer}>
            <OnSaleEventPage
              eventId={Number(sanitizedEventId)}
              returnUrl={returnUrl}
            />
          </div>
        </LayoutContent>
      </DialogProvider>
    </StopwatchLoggingContextProvider>
  );
};
